module.exports = __webpack_public_path__ + "img/mgh-fukuoka-nakasu.1a88133a.jpg";